import { IDs } from '../../../helpers/IDs';
import { lazyInject } from '../../../services/inversify';
import * as React from 'react';
import { TriggerService } from '../../../core/trigger/trigger_service';
import { WFormsTableWrapper } from '../../../core/table/WFormsTableWrapper';

interface ReportTextProps extends React.ClassAttributes<any> {
    data: any;
    standort: number;
    keyData: string;
    onClose: () => void;
}

interface ReportTextState {
    tid: number;
}

export class ReportText extends React.Component<ReportTextProps, ReportTextState> {

    constructor(props: any) {
        super(props);
        this.state = {
            tid: null
        };
    }

    @lazyInject(TriggerService) private triggerService: TriggerService;

    componentDidMount(): void {
        if (typeof this.props.standort !== 'number' || typeof this.props.keyData !== 'string') {
            return;
        }
        const tid: number = (((this.props.data || {})[IDs.ENT_VSME_REPORT] || []).find((item: any) =>
            (item.standort_tid_orig || item.standort_tid) === this.props.standort && item.key_group === this.props.keyData) || {}).tid || 0;
        this.setState({ tid });
    }

    render(): JSX.Element {
        if (this.state.tid === null) {
            return null;
        }

        return (
            <WFormsTableWrapper
                entity={IDs.ENT_VSME_REPORT}
                module={IDs.MOD_ETOOL}
                directEditFormularOf={{ tid: this.state.tid }}
                formPreset={{ standort_tid: this.props.standort, key_group: this.props.keyData }}
                customFormConfig={{ standort_tid: { hidden: true }, key_group: { hidden: true } }}
                inlineFormular
                showDeleteInSaveDialog
                onAfterAction={(action: string) => {
                    if (action === 'saveDone' || action === 'delDone') {
                        this.triggerService.fire('reload', IDs.ENT_VSME_REPORT);
                        this.props.onClose();
                    }
                }}
                formLayout='flowV2'
                customClass='Custom-ETA'
                customCssStyle={{
                    formcontainer: { minWidth: 500 },
                    formField: { text: { styleTextarea: { height: 350 } } }
                }}
            />
        );
    }
}
